import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// BrowserRouter is now inside App (via GameProvider)
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
